<template>
  <default-modal ref="box" :title="title" :confirmTxt="confirmText" @confirm="confirm">
    <div class="modal-body">
      <div class="row">
        <span class="left">任务文件：</span>
        <div style="float:left;">
          <Select v-model="taskFileId" clearable filterable placeholder="请选择文件" style="width:300px;display:inline-block"
            :disabled="customize ? true : false" @on-change="onChangeStripe">
            <Option v-for="(item, index) in fileList" :value="item.fileId" :key="index" :label="item.remark
              ? item.fileName + '(' + item.remark + ')'
              : item.fileName
              ">
              <span v-text="item.fileName"></span>
              <div v-show="item.remark" style="display:inline-block">
                (<span v-text="item.remark"></span>)
              </div>
            </Option>
          </Select>
          <file-upload ref="fileUpload" :format="[
            'exe',
            'bat',
            'ps1',
            'rar',
            'zip',
            '7z',
            'reg',
            'txt',
            'dll',
            'ini',
            'cfg',
            'doc',
            'docx',
            'xls',
            'xlsx',
            'jpg',
            'gif',
            'png',
            'bmp',
            'vbs',
          ]" :url="$HTTP_API.threeTierMission.uploadFile" :size="32768" @fileResult="fileResult"
            style="display:inline-block;margin:0 0 10px 10px"></file-upload>
          <div>
            <input class="com" type="text" v-model="fileUrl" placeholder="仅支持HTTP或HTTPS下载地址，不支持FTP"
              :disabled="customize ? false : true" />
            <input type="checkbox" v-model="customize" class="checkbox customize" />
            自定义下载链接
          </div>
        </div>
      </div>
      <div class="row">
        <span class="left">任务名称：</span>
        <input class="com" type="text" v-model="taskName" placeholder="默认读取文件名可修改" />
      </div>
      <div class="row">
        <span class="left">执行方式：</span>
        <Select v-model="runType" style="width:150px">
          <Option v-for="(item, index) in runTypeList" :value="item.ruleId" :key="index">{{ item.ruleName }}</Option>
        </Select>

        <flat-pickr v-model="time" :config="config" class="way" v-show="taskType == 0 && runType == 3"></flat-pickr>
        <span style="margin-left:10px; color:#666;"
          v-if="runType == 2 || runType == 3 || runType == 4">支持：exe、bat、cmd、vbs、reg类型文件</span>
        <div v-show="taskType == 0 && runType == 3">
          <Select v-model="weekIdList" multiple style="width:400px;margin:10px 5px 0 90px;" @on-change="changeWeek">
            <Option v-for="(item, index) in weekList" :value="item.value" :key="index">{{ item.label }}</Option>
          </Select>
          <div style="display: inline-block;position: relative;top: 3px;">
            <input type="checkbox" v-model="bRepeat" class="checkbox" />
            重复执行
          </div>
        </div>
        <p v-show="taskType == 1 && runType == 2" style="margin-top:-14px;text-indent:160px;">
          该方式仅在现在开机的客户机执行
        </p>
        <p v-show="taskType == 1 && runType == 4" style="margin-top:-14px;text-indent:160px;">
          该方式仅在每次重新开机的客户机执行
        </p>
      </div>
      <div class="row" v-show="taskType == 1">
        <span class="left"></span>
        <input type="checkbox" v-model="superRun" class="checkbox" />
        无盘超管状态不执行
      </div>
      <div class="row dropDown">
        <div class="border" style="width:50px;"></div>
        <div @click.prevent="showDrop = !showDrop">
          <span>高级设置</span>
          <img src="@/assets/img/icon/u2898.svg" alt="" v-show="showDrop" />
          <img src="@/assets/img/icon/u2898.svg" alt="" style="transform: rotate(180deg);" v-show="!showDrop" />
        </div>
        <div class="border" style="min-width:400px;"></div>
      </div>
      <div v-show="showDrop">
        <div class="row">
          <span class="left">存储位置：</span>
          <input class="com" type="text" v-model="localFilePath" placeholder="默认设置路径" />
        </div>
        <div class="row" style="margin:0;height: 16px;">
          <span class="left"></span>
          <span v-show="taskType == 0">默认设置路径：维护大师服务端目录下的“wzServerTaskPkg”</span>
          <span v-show="taskType == 1">默认设置路径：维护大师客户端目录下的“wzClientTaskPkg”</span>
        </div>
        <div class="row">
          <span class="left">参数执行：</span>
          <textarea v-model="param" name="" id="" cols="10" rows="2" placeholder="输入参数（选填）"></textarea>
        </div>
        <div class="row" style="margin:0;">
          <span class="left">其他设置：</span>
          <div style="float:left;line-height:30px;">
            <input type="checkbox" v-model="bHideWindow" class="checkbox" />
            隐藏窗口执行
          </div>
        </div>
        <div class="row" style="margin:0;height: 16px;">
          <span class="left"></span>
          <span class="tips">注意：当系统没有用户登录时，程序在任何时候都会隐藏窗口执行。</span>
        </div>
      </div>
    </div>
  </default-modal>
</template>
<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import FileUpload from '_c/uploadFile' // 引入上传文件组件
import DefaultModal from '_c/modals/defaultModal'
import { getAllFile, createTask } from '@/requests/threeTierMission'
import { Base64 } from 'js-base64'
export default {
  components: {
    DefaultModal,
    FileUpload,
    flatPickr,
  },
  data () {
    return {
      fileUrl: '',
      fileList: [],
      runTypeList: [],
      taskFileId: '',
      customize: false,
      taskName: '',
      runType: 0,
      localFilePath: '',
      weekIdList: [],
      weekList: [
        {
          value: 1,
          label: '周一',
        },
        {
          value: 2,
          label: '周二',
        },
        {
          value: 4,
          label: '周三',
        },
        {
          value: 8,
          label: '周四',
        },
        {
          value: 16,
          label: '周五',
        },
        {
          value: 32,
          label: '周六',
        },
        {
          value: 64,
          label: '周日',
        },
      ],
      nWeekDaylist: 0,
      param: '',
      bHideWindow: false,
      time: '',
      beginHour: '',
      beginMinute: '',
      bRepeat: false,
      superRun: false,
      taskType: 0,
      title: '',
      config: {
        noCalendar: true,
        dateFormat: 'H:i', // data变成时间戳
        altFormat: 'H:i', // 选择时显示的时间
        enableTime: true, // 选择小时分种
        defaultHour: 8, // 默认8点
        time_24hr: true, // 时间24小时制
      },
      confirmText: '创建',
      successFn: '',
      showDrop: true,
    }
  },
  watch: {
    customize () {
      if (this.customize) {
        this.taskFileId = ''
      }
    },
    fileUrl () {
      this.getFileName(this.fileUrl)
    },
    taskFileId () {
      for (let item of this.fileList) {
        if (this.taskFileId == item.fileId) {
          this.taskName = item.fileName
        }
      }
    },
  },
  mounted () {
    window.$modal.createTaskModal = {}
    window.$modal.createTaskModal.show = (val) => {
      this.taskType = val
      if (val == 0) {
        this.title = '创建服务器任务'
      } else {
        this.title = '创建客户机任务'
      }
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true)
        })
      })
    }
    // 监听键盘按键事件
    let self = this
    this.$nextTick(function () {
      document.addEventListener('keyup', function (e) {
        // 此处填写你的业务逻辑即可
        if (e.keyCode == 27) {
          self.$refs.box.hide()
        }
      })
    })
  },
  methods: {
    getFileName (val) {
      let pos = val.lastIndexOf('\/')
      let pos2 = val.lastIndexOf('.')
      // strFileName=str.substring(pos+1);//文件名带后缀
      this.taskName = val.substring(pos + 1, pos2) // 文件名不带后缀
    },
    onChangeStripe (e) {
      console.log(e)
    },
    // 初始化信息
    init (fn) {
      this.$refs.box.show()
      this.taskFileId = ''
      this.fileUrl = ''
      this.taskName = ''
      this.runType = 0
      this.weekIdList = []
      this.localFilePath = ''
      this.param = ''
      this.bHideWindow = false
      this.time = ''
      this.bRepeat = false
      this.superRun = false
      this.getAllFile()
      this.getRuleType()
      this.successFn = fn
    },
    async getAllFile () {
      let res = await getAllFile()
      this.fileList = res.data
    },
    async getRuleType () {
      if (this.taskType == 0) {
        this.runTypeList = [
          {
            ruleId: 2,
            ruleName: '下载后立即执行',
          },
          {
            ruleId: 1,
            ruleName: '仅下载不执行',
          },
          {
            ruleId: 3,
            ruleName: '定时执行',
          },
        ]
      } else {
        this.runTypeList = [
          {
            ruleId: 1,
            ruleName: '仅下载不执行',
          },
          {
            ruleId: 4,
            ruleName: '每次开机时执行',
          },
          {
            ruleId: 2,
            ruleName: '下载后立即执行',
          },
        ]
      }
    },
    async fileResult (res) {
      await this.getAllFile()
      this.$emit('getUsage')
      for (let item of this.fileList) {
        if (res.data == item.fileId) {
          this.taskFileId = res.data
        }
      }
    },
    changeWeek () {
      this.nWeekDaylist = 0
      this.weekIdList.forEach((item) => {
        this.nWeekDaylist = this.nWeekDaylist + item
      })
    },
    async confirm () {
      if (!this.taskFileId && !this.fileUrl) {
        return this.$refs.box.setWrong(
          '请选择文件或输入http或HTTPS链接下载文件'
        )
      }
      if (!this.runType) {
        return this.$refs.box.setWrong('请输入执行方式')
      }
      let obj = {
        fileId: this.taskFileId ? this.taskFileId : '',
        url: this.fileUrl,
        taskName: Base64.encode(this.taskName).replace(/\+/g, '%2B'),
        runType: this.runType,
        nWeekDaylist: this.nWeekDaylist,
        localFilePath: this.localFilePath,
        param: this.param,
        bHideWindow: this.bHideWindow,
        beginHour: this.time ? this.time.split(':')[0] : 8,
        beginMinute: this.time ? this.time.split(':')[1] : 0,
        bRepeat: this.bRepeat,
        superRun: this.superRun,
        taskType: this.taskType,
      }
      let key = this.$MethodFn.guidFn().slice(0, 16)
      let key2 = this.$MethodFn.rsaEncry(key)
      let data2 = {
        key: key2,
        data: this.$MethodFn.AesEncode(JSON.stringify(obj), key)
      }
      let json = {
        data: this.$MethodFn.Base64(JSON.stringify(data2))
      }
      let resValue = await createTask(json)
      if (resValue.code == 200) {
        this.$refs.box.hide()
        this.successFn()
      } else {
        this.$refs.box.setWrong(resValue.msg)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 10px;
  text-align: left;
  position: relative;

  .row {
    overflow: hidden;
    margin: 10px 0;

    .left {
      float: left;
      margin-right: 10px;
      min-width: 80px;
      display: inline-block;
      text-align: right;
      height: 30px;
      line-height: 30px;
    }
  }

  select {
    width: 200px;
  }

  input.com {
    width: 300px;
    height: 30px;
    border: 1px solid rgba(215, 215, 215, 1);
    font-size: 12px;
    color: #515151;
    text-align: left;
    padding-left: 10px;
  }

  .way {
    width: 70px;
    margin: 0px 5px;
    border: 1px solid rgb(215, 215, 215);
    height: 32px;
    border-radius: 3px;
    padding-left: 5px;
    display: inline-block;
  }

  .checkbox {
    position: relative;
    top: 2px;
  }

  .customize {
    margin-left: 10px;
  }

  textarea {
    padding: 9px;
    width: 400px;
    height: 50px;
    white-space: nowrap;
    overflow: auto;
    border: 1px solid rgba(215, 215, 215, 1);
  }

  .dropDown {
    color: rgb(0, 153, 204);
    padding-left: 22px;

    div {
      display: inline-block;
      cursor: pointer;
    }

    .border {
      border-bottom: 1px solid rgba(215, 215, 215, 1);
      margin-bottom: 2px;
    }

    img {
      margin: 0 10px 0 8px;
    }

    span {
      margin-left: 10px;
    }
  }

  .tips {
    color: rgb(217, 0, 27);
    font-size: 12px;
  }
}
</style>
